import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';
import { TariffCard } from '../../../../components/cards/TariffCard.jsx';

// Die Komponente, die im Designer Canvas (und später im Frontend) gerendert wird
export function TariffCardRender({ node, isLiveMode }) {
  const content = node.content || {};
  
  // Wir übergeben fast alle Props 1:1 an die echte TariffCard
  // Der BaseWidget-Wrapper (in layout/DesignerCanvas.jsx) kümmert sich um den Rahmen
  return (
    <div style={{ pointerEvents: !isLiveMode ? 'none' : 'auto' }}>
      <TariffCard 
        {...content}
        activeEvent={content.activeEvent || 'none'}
        // Damit Links/Buttons im Canvas nicht feuern
        onSelectToggle={() => {}}
        onPrint={() => {}}
        onEditRequest={() => {}}
      />
    </div>
  );
}

// Registrierung im TEF Designer
registry.register('TariffCard', {
  label: 'Tarif-Karte',
  icon: '📱', 
  category: 'tef',
  component: TariffCardRender,
  
  // Standard-Inhalt beim Reinziehen
  defaultProps: {
    content: {
      title: 'O2 Mobile M',
      dataLabel: '25',
      price: 32.99,
      promoPrice: 29.99,
      connectionFee: 39.99,
      category: 'Junge Leute',
      group: 'young',
      segment: 'mobile',
      showValidityLeft: false,
      startsOn: '',
      expiresOn: '',
      isComboDiscounted: false,
      originalPrice: 32.99,
      comboDiscount: '50%',
      features: [
        '25 GB+ Highspeed-Daten',
        'Jedes Jahr 5 GB monatlich mehr',
        '4G LTE/5G (max. 300 MBit/s)',
        'Allnet-Flat Telefon- & SMS'
      ]
    },
    // CSS Fallbacks
    style: {
      desktop: {
        width: '320px',
        margin: '10px'
      }
    }
  },

  // Diese Felder sieht der Nutzer rechts im Inspector
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Basis-Daten',
          fields: [
            { name: 'content.title', label: 'Tarifname', type: 'text' },
            { name: 'content.dataLabel', label: 'Gigabyte (Zahl oder "unbegrenzt")', type: 'text' },
            { name: 'content.segment', label: 'Segment', type: 'select', options: [
              { value: 'mobile', label: 'O2 Mobile' },
              { value: 'prepaid', label: 'O2 Prepaid' },
              { value: 'blue', label: 'O2 Blue' },
              { value: 'myhome', label: 'O2 Home' }
            ]},
            { name: 'content.category', label: 'Kategorie/Badge', type: 'select', options: [
              { value: 'Neuvertrag', label: 'Neuvertrag' },
              { value: 'Junge Leute', label: 'Junge Leute' },
              { value: '60 Plus', label: '60 Plus' },
              { value: 'Kombivorteil', label: 'Kombivorteil' },
              { value: 'Promo Aktion', label: 'Promo Aktion' },
              { value: 'Ohne Rabatt', label: 'Ohne Rabatt' }
            ]},
          ]
        },
        {
          title: 'Preise & Kosten',
          fields: [
            { name: 'content.price', label: 'Normalpreis (€)', type: 'number', step: '0.01' },
            { name: 'content.promoPrice', label: 'Aktionspreis (€)', type: 'number', step: '0.01' },
            { name: 'content.connectionFee', label: 'Anschlusspreis (€)', type: 'number', step: '0.01' },
          ]
        },
        {
          title: 'Kombi-Vorteil Logik',
          fields: [
            { name: 'content.isComboDiscounted', label: 'Ist ein Kombi-Angebot?', type: 'boolean' },
            { name: 'content.comboDiscount', label: 'Kombi-Text (z.B. 50%)', type: 'text' },
            { name: 'content.originalPrice', label: 'Originalpreis (Für Streichpreis)', type: 'number', step: '0.01' }
          ]
        },
        {
          title: 'Gültigkeit (Timer)',
          fields: [
            { name: 'content.startsOn', label: 'Startdatum (DD.MM.YYYY)', type: 'text' },
            { name: 'content.expiresOn', label: 'Ablaufdatum (DD.MM.YYYY)', type: 'text' },
            { name: 'content.showValidityLeft', label: 'Badge statt Text nutzen?', type: 'boolean' }
          ]
        }
      ]
    }
  ]
});
